import { serviceGo } from '@/utils/request'

// 章节耗时统计：每个章节一项
export interface ChapterTimeStat {
  chapter_order: number          // 章节序号
  completed_count: number        // 完成本章人数（=进入过下一章的用户数）
  duration_minutes: number | null // 本章耗时（分钟，中位数）；无完成者为 null
  cumulative_minutes: number     // 累积耗时（分钟）
}

export interface ChapterTimeStatsParams {
  game_id: number
  start_date: string  // 'yyyy-MM-dd' 注册开始日期
  end_date: string    // 'yyyy-MM-dd' 注册结束日期
  n_days?: number     // N 日内窗口，默认 0
  channels?: string   // toutiao/kuaishou/other；'全部'时不传
}

// 拉取章节耗时统计（Go 后端，需管理员权限）
export async function getChapterTimeStats(params: ChapterTimeStatsParams): Promise<ChapterTimeStat[]> {
  const res = await serviceGo.get('/api_v2/admin/chapter-time-stats', { params })
  return res.data.data?.chapters || []
}
